<template>
  <div
    v-if="show"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    @click.self="$emit('close')"
  >
    <div class="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-xl">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-lg font-bold text-blue">{{ $t("orders.scan-ticket") }}</h2>
        <button
          class="p-2 rounded-full hover:bg-gray-100 transition"
          @click="$emit('close')"
        >
          <c-icon name="CloseRound" size="1.2rem" class="text-gray-400" />
        </button>
      </div>
      <div class="text-gray-400 text-sm mb-4">
        {{ $t("orders.scan-ticket-description") }}
      </div>
      <div class="flex flex-col items-center justify-center h-[350px]">
        <video
          v-show="!imageSource"
          id="video"
          autoplay
          playsinline
          class="h-full rounded-xl object-cover"
        ></video>
        <img
          v-if="imageSource"
          id="photo"
          :src="imageSource"
          alt="Captured Photo"
          class="h-[350px] rounded-xl object-cover"
        />
      </div>
      <canvas id="canvas" style="display: none"></canvas>
      <div
        v-if="!imageSource"
        class="flex flex-row items-center justify-center mt-6"
      >
        <button
          class="px-6 py-3 rounded-xl text-white font-semibold transition hover:opacity-90"
          :style="{ backgroundColor: accentColor }"
          @click="handleButtonClick"
        >
          {{ $t("orders.take-photo") }}
        </button>
      </div>
      <div
        v-else
        class="flex flex-row items-center justify-center mt-6 space-x-4"
        :class="{ 'opacity-50 pointer-events-none': loading }"
      >
        <button
          class="px-6 py-3 rounded-xl font-semibold border transition hover:opacity-90"
          :style="{ borderColor: accentColor, color: accentColor }"
          @click="handleCancel"
        >
          {{ $t("cancel") }}
        </button>
        <button
          class="px-6 py-3 rounded-xl text-white font-semibold transition hover:opacity-90"
          :style="{ backgroundColor: accentColor }"
          @click="handleConfirm"
        >
          {{ $t("accept") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CIcon from "../../../core-ui/src/components/CIcon.vue";
import { mapState } from "pinia";
import { authStore } from "@/stores/auth";

export default {
  name: "ImageRecorder",
  components: { CIcon },
  data() {
    return {
      imageSource: null,
      loading: false,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(authStore, ["branding"]),
    accentColor() {
      return this.branding?.accentColor || "#6B9AE1";
    },
  },
  methods: {
    handleCancel() {
      this.imageSource = null;
    },
    handleConfirm() {
      let that = this;
      this.loading = true;
      fetch(this.imageSource)
        .then((res) => res.blob())
        .then((blob) => {
          const formData = new FormData();
          formData.append("file", blob);
          formData.append("upload_preset", "unsigned-preset");
          return fetch("https://api.cloudinary.com/v1_1/comebackapp/upload", {
            method: "POST",
            body: formData,
          });
        })
        .then((res) => res.json())
        .then((data) => {
          that.loading = false;
          that.$emit("image", data.public_id);
        })
        .catch((err) => {
          console.error("Upload failed:", err);
          that.loading = false;
        });
    },
    handleButtonClick() {
      let canvas = document.getElementById("canvas");
      let video = document.getElementById("video");

      const context = canvas.getContext("2d");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.imageSource = canvas.toDataURL("image/png");
    },
    stopCamera() {
      let video = document.getElementById("video");
      if (video && video.srcObject) {
        video.srcObject.getTracks().forEach((track) => track.stop());
        video.srcObject = null;
      }
    },
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.imageSource = null;
        this.$nextTick(() => {
          let video = document.getElementById("video");

          // Ask for camera access
          navigator.mediaDevices
            .getUserMedia({ video: { facingMode: "environment" } })
            .then((stream) => {
              video.srcObject = stream;
            })
            .catch((err) => {
              console.error("Camera access error:", err);
              this.$notificationGenerator.error(this.$t("orders.camera-access-error"));
            });
        });
      } else {
        this.stopCamera();
      }
    },
  },
  beforeUnmount() {
    this.stopCamera();
  },
};
</script>

<style scoped></style>
